import { Bus } from '@/event-bus.js'
import Vue from 'vue'

export default{
    getSoloGame : state => {
        let stateSolo = state.soloGame
        return stateSolo 
    },
    getLastSolo : state => {
        return state.soloGame[state.soloGame.length - 1]
    },
    getGameSetId : state => {
        if (state.gameSetId.length !== 0) return state.gameSetId
        return localStorage.getItem('gameSetId')
    },
    getNow : state => {
        return state.now
    }
}